/**
 * The games this device works in, remembered in localStorage
 * (`seagames.mses.games_id`). A tiny external store — the games switch in the
 * sidebar writes it, every page that lists something reads it — so a choice
 * made anywhere shows everywhere at once. Storage is best-effort: private
 * mode or a full disk throws, and the choice then lives for this tab only.
 */
export const CURRENT_GAMES_KEY = "seagames.mses.games_id";

export interface ChoiceStore {
	get(): string | null;
	set(id: string): void;
	subscribe(listener: () => void): () => void;
}

export function createChoiceStore(storage: Pick<Storage, "getItem" | "setItem"> | undefined): ChoiceStore {
	let current: string | null = null;
	try {
		current = storage?.getItem(CURRENT_GAMES_KEY) ?? null;
	} catch {
		current = null;
	}
	const listeners = new Set<() => void>();
	return {
		get: () => current,
		set(id) {
			if (id === current) return;
			current = id;
			try {
				storage?.setItem(CURRENT_GAMES_KEY, id);
			} catch {
				// Kept in memory for this tab.
			}
			for (const l of listeners) l();
		},
		subscribe(listener) {
			listeners.add(listener);
			return () => listeners.delete(listener);
		},
	};
}
